import gsap from "gsap/all";

export default () => ({
  flagTopLeft: ".logo .flag-top-left",
  flagTopRight: ".logo .flag-top-right",
  flagBottomLeft: ".logo .flag-bottom-left",
  flagBottomRight: ".logo .flag-bottom-right",
  logoText: ".logo .logo-text",

  init() {
    if (this.isFirstVisit) {
      this.initLogoAnimation();
    }
  },

  get isFirstVisit() {
    const date = parseInt(localStorage.getItem("visit-date"));
    //no visit date
    if (!date) {
      return this.setFirstVisit();
    }

    // check for expiration
    const oneDay = 43200000; // 24 hours in milliseconds
    const expired = date < Date.now() - oneDay;

    // has visit date but is expired
    if (expired) {
      return this.setFirstVisit();
    }

    return false;
  },

  setFirstVisit() {
    localStorage.setItem("visit-date", Date.now().toString());
    return true;
  },

  initLogoAnimation() {
    gsap.set(".flag", {
      xPercent: -100,
      fillOpacity: 0,
    });
    gsap.set(".logo-text", {
      xPercent: -30,
      fillOpacity: 0,
    });

    gsap
      .timeline()
      .to(this.flagBottomRight, {
        xPercent: 0,
        fillOpacity: 1,
        delay: 0.3,
      })
      .to(
        this.flagTopRight,
        {
          xPercent: 0,
          fillOpacity: 1,
        },
        "-=0.3"
      )
      .to(
        [this.flagTopLeft, this.flagBottomLeft],
        {
          xPercent: 0,
          fillOpacity: 1,
        },
        "-=0.4"
      )
      .to(
        this.logoText,
        {
          xPercent: 0,
          fillOpacity: 1,
        },
        "-=0.3"
      );
  },
});
